import enviro from 'enviro';
export const APP_CERTIFICATION_CREDENTIAL_ID = enviro.isQa() ? 1089774 : 111001;